const ENV_DIRECT_URL = (
  process.env.VUE_APP_DIRECT_URL || 'https://app.improve.online'
).replace(/\/$/, '');

const LOCAL_APP_URL = (
  process.env.VUE_APP_LOCAL_APP_URL || 'http://localhost:8081'
).replace(/\/$/, '');

/**
 * App URL for trial/login links. Follows the site you are on:
 * local marketing → local app, staging site → staging app, otherwise env/prod.
 */
export function resolveDirectAppUrl() {
  if (typeof window === 'undefined' || !window.location) {
    return ENV_DIRECT_URL;
  }

  // At build time scripts/prerender.js renders every page from a local server
  // and says which PUBLIC host the snapshot is for; without this the static
  // HTML would carry http://localhost links in its navigation.
  const host = window.__PRERENDER_HOST__ || window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') {
    if (/localhost|127\.0\.0\.1/.test(ENV_DIRECT_URL)) {
      return ENV_DIRECT_URL;
    }
    return LOCAL_APP_URL;
  }

  if (host.indexOf('staging') !== -1) {
    return 'https://staging.improve.online';
  }

  return ENV_DIRECT_URL;
}

/*
  Export the configuration.
*/
export const IMPROVE_CONFIG = {
  API_URL: process.env.VUE_APP_API_URL,
  SERVERLESS_IMAGE_HANDLER: "https://d21qlfkuyb2o0k.cloudfront.net",
  BUCKET: process.env.VUE_APP_BUCKET,
  STRIPE: process.env.VUE_APP_STRIPE,
  get DIRECT_URL() {
    return resolveDirectAppUrl();
  },
  PARTNER_URL: process.env.VUE_APP_PARTNER_URL || 'https://partner.improve.online/#/login',
};
